import React from 'react';
import { getExtensionCmpByViewPath } from '../util/extension';

export default class ComponentHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(this.props.setEmptyHeight) {
            const cmpContainer = this.refs.cmpContainer;
            this.props.setEmptyHeight(cmpContainer.offsetHeight);
        }
    }

    render() {
        const { componentName, ...others } = this.props;
        const CustomComponent = getExtensionCmpByViewPath(componentName);
        return (<div className={componentName + '-container'} ref="cmpContainer">
                    <CustomComponent {...others} />
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/ComponentHolder.js